import { render, staticRenderFns } from "./historyByHc.vue?vue&type=template&id=492f0526&scoped=true"
import script from "./historyByHc.vue?vue&type=script&lang=js"
export * from "./historyByHc.vue?vue&type=script&lang=js"
import style0 from "./historyByHc.vue?vue&type=style&index=0&id=492f0526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f0526",
  null
  
)

export default component.exports